import { variables } from '@indriver/yrel';

var preset = {
  backgroundColor: {
    primary: variables['border-primary'],
    brand: variables['extensions-border-success'],
    accent: variables['extensions-border-accent'],
    error: variables['extensions-border-error'],
    disabled: variables['border-disabled']
  }
};

export { preset as default };
